import axios from './../../axios-auth'
import utils from '@/utils'

const state = {
  currentUser: {},
  powerOfAttorney: null
}

const getters = {
  currentUser: state => state.currentUser,
  powerOfAttorney: state => state.powerOfAttorney
}

const actions = {
  addRolePolicyHolder ({getters, dispatch, commit}, payload) {
    return new Promise((resolve, reject) => {
      const currentUser = getters.currentUser
      const idToken = state.currentUser.idToken
      const authValue = 'Bearer '.concat(idToken)
      axios.post(`/users/${currentUser.id}/addRolePolicyHolder`, payload, {
        headers: {
          Authorization: authValue
        }
      }).then((response) => {
        const user = {
          ...currentUser,
          roles: response.data.roles
        }
        commit('setCurrentUser', user)
        dispatch('setLogoutTimer')
        resolve()
      }).catch((err) => reject(err))
    })
  },
  changeEmail ({dispatch, state}, email) {
    return new Promise((resolve, reject) => {
      const attributes = []
      const emailAttr = {
        Name: 'email',
        Value: email
      }
      attributes.push(emailAttr)
      dispatch('updateAttributes', attributes)
        .then(() => {
          return dispatch('setCurrentUser', {
            cognitoId: state.currentUser.cognitoId,
            idToken: state.currentUser.idToken,
            accessToken: state.currentUser.accessToken,
            refreshToken: state.currentUser.refreshToken
          })
        })
        .then(() => {
          dispatch('setLogoutTimer')
          resolve()
        })
        .catch((err) => {
          reject(err)
        })
    })
  },
  changedPassword ({state, dispatch}) {
    return new Promise((resolve, reject) => {
      const idToken = state.currentUser.idToken
      const authValue = 'Bearer '.concat(idToken)
      axios.get(`/users/${state.currentUser.id}/changedPassword`, {
        headers: {
          Authorization: authValue
        }
      }).then(() => {
        dispatch('setLogoutTimer')
        resolve()
      }).catch(() => reject())
    })
  },
  deleteCurrentUser ({state}) {
    const idToken = state.currentUser.idToken
    const authValue = 'Bearer '.concat(idToken)
    return axios.delete(`/users/${state.currentUser.id}`, {
      headers: {
        Authorization: authValue
      }
    })
  },
  deletePowerOfAttorney ({commit, dispatch, state}) {
    return new Promise((resolve, reject) => {
      const idToken = state.currentUser.idToken
      const authValue = 'Bearer '.concat(idToken)
      axios.delete(`/users/${state.currentUser.id}/powerOfAttorny`, {
        headers: {
          Authorization: authValue
        }
      }).then(() => {
        commit('setPowerOfAttorney', null)
        dispatch('setLogoutTimer')
        resolve()
      }).catch((err) => {
        reject(err)
      })
    })
  },
  getPowerOfAttorney ({commit, dispatch, state}) {
    const idToken = state.currentUser.idToken
    const authValue = 'Bearer '.concat(idToken)
    return new Promise((resolve, reject) => {
      axios.get(`/users/${state.currentUser.id}/powerOfAttorny`, {
        responseType: 'arraybuffer',
        headers: {
          Authorization: authValue,
          'Content-Type': 'application/json'
        }
      }).then((response) => {
        const poaMeta = utils.contentDispositionToMeta(response)
        poaMeta.file = response.data
        commit('setPowerOfAttorney', poaMeta)
        dispatch('setLogoutTimer')
        resolve(poaMeta)
      }).catch((err) => {
        switch (err.response.status) {
          case 404: { // no poa uploaded yet
            dispatch('setLogoutTimer')
            resolve()
            break
          }
          default: {
            reject(err)
          }
        }
      })
    })
  },
  uploadPowerOfAttorney ({commit, dispatch, state}, file) {
    return new Promise((resolve, reject) => {
      const idToken = state.currentUser.idToken
      const authValue = 'Bearer '.concat(idToken)
      const formData = new FormData()
      formData.append('file', file)
      axios.post(`/users/${state.currentUser.id}/powerOfAttorny`,
        formData,
        {
          headers: {
            Authorization: authValue
          }
        }
      ).then(() => {
        const powerOfAttorneyMeta = {}
        powerOfAttorneyMeta.filename = file.name
        powerOfAttorneyMeta.mimeType = file.type
        powerOfAttorneyMeta.file = file
        commit('setPowerOfAttorney', powerOfAttorneyMeta)
        dispatch('setLogoutTimer')
        resolve()
      }).catch((err) => reject(err))
    })
  },
  setCurrentUser ({commit, dispatch}, cognitoUserData) {
    return new Promise((resolve, reject) => {
      const idToken = cognitoUserData.idToken
      const authValue = 'Bearer '.concat(idToken)
      axios.get('/users/current', {
        headers: {
          Authorization: authValue
        }
      }).then((response) => {
        const data = response.data
        const user = {
          id: data.id,
          avatar: data.avatar,
          cognitoId: cognitoUserData.cognitoId,
          idToken: cognitoUserData.idToken,
          accessToken: cognitoUserData.accessToken,
          refreshToken: cognitoUserData.refreshToken,
          expirationDate: cognitoUserData.expirationDate,
          contractNumber: data.contractNumber,
          email: data.email,
          dateOfBirth: data.dateOfBirth,
          dateOfDeath: data.dateOfDeath,
          firstName: data.firstName,
          lastName: data.lastName,
          roles: data.roles,
          salutation: data.salutation,
          title: data.title
        }
        commit('setCurrentUser', user)
        dispatch('setLogoutTimer')
        resolve()
      }).catch((err) => reject(err))
    })
  },
  updateUser ({commit, dispatch, state}, user) {
    return new Promise((resolve, reject) => {
      const idToken = state.currentUser.idToken
      const authValue = 'Bearer '.concat(idToken)
      axios.put(`/users/${user.id}`, user, {
        headers: {
          Authorization: authValue
        }
      }).then(() => {
        dispatch('setLogoutTimer')
        resolve()
      }).catch(() => reject())
    })
  },
  deleteAvatar ({state, dispatch}) {
    return new Promise((resolve, reject) => {
      const idToken = state.currentUser.idToken
      const authValue = 'Bearer '.concat(idToken)
      axios.delete(`/avatars/${state.currentUser.avatar.uuid}`, {
        headers: {
          Authorization: authValue
        }
      }).then(() => {
        state.currentUser.avatar = null
        dispatch('setLogoutTimer')
        resolve()
      }).catch(() => reject())
    })
  },
  uploadAvatar ({commit, state, dispatch}, avatar) {
    return new Promise((resolve, reject) => {
      const idToken = state.currentUser.idToken
      const authValue = 'Bearer '.concat(idToken)
      const formData = new FormData()
      formData.append('file', avatar)
      if (!state.currentUser.avatar) {
        axios.post(`/avatars/`, formData, {
          headers: {
            Authorization: authValue
          }
        }).then((response) => {
          const location = response.headers.location
          const uuid = location.substr(location.lastIndexOf('/') + 1, location.length)
          state.currentUser.avatar = {uuid: uuid}
          dispatch('setLogoutTimer')
          resolve()
        }).catch(() => reject())
      } else {
        axios.put(`/avatars/${state.currentUser.avatar.uuid}`, formData, {
          headers: {
            Authorization: authValue
          }
        }).then((response) => {
          dispatch('setLogoutTimer')
          resolve()
        }).catch(() => reject())
      }
    })
  },
  validateContractNumber ({commit}, data) {
    return axios.post('/users/validateContractNumber', data)
  }
}

const mutations = {
  setCurrentUser (state, user) {
    state.currentUser = user
  },
  setPowerOfAttorney (state, powerOfAttorney) {
    state.powerOfAttorney = powerOfAttorney
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/users.js